export default __webpack_public_path__ + "static/media/trr-food-smallplate-brussellsprouts.e8638225.png";